import { render, staticRenderFns } from "./sxqyResearcreport.vue?vue&type=template&id=a5daa928&scoped=true&"
import script from "./sxqyResearcreport.vue?vue&type=script&lang=js&"
export * from "./sxqyResearcreport.vue?vue&type=script&lang=js&"
import style0 from "./sxqyResearcreport.vue?vue&type=style&index=0&id=a5daa928&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5daa928",
  null
  
)

export default component.exports